import Player from "video-react/lib/components/Player"

export const MobileApp = () => {
  return (
    <div>
      <div id='category'>
        <div>
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="about-text">
                <h2>GREYHOUND APP</h2>
                <h4>Is Android & iOS application where you can add your Cardano addresses containing greyhounds and be able to access to different features.</h4>
                <h4>Receive news about social media related to The Greyhound Society and future events such The Founder's Story or Greyhound Tournaments.</h4>
                <h4>Adding your Cardano wallet address and holding a Greyhound you will be elegible for Tournaments where you can get more Greyhounds, you will be able to see your own greyhounds and share them and naviagte through every greyhound and see important information.</h4>
                <h4>The Founder Story: This will be the heart of the app, here you will find the story behind this society, here is where you will be able to win Legendary Greyhounds. Future events will reveal clues and information about The Founder's journey in search of the treasures.</h4>
              </div>
            </div>
            <div className="col-xs-12 col-md-6" style={{ display: 'flex', justifyContent: 'center' }}>
              <img src={'./img/app.png'} className="img-responsive" alt="" />{" "}
            </div>
          </div>
        </div>
      </div>
      <div>
        <h3 style={{ color: "white" }}>PROTOTYPE UNDER DEVELOPMENT</h3>
        <Player width='700' autoPlay playsInline>
          <source src="img/gm.mp4" />
        </Player>
      </div>
    </div>
  )
}
